export default __webpack_public_path__ + "static/media/endlessstart.d323a197.png";